<p-toast></p-toast>

<div class="bsr-container">

  <!-- Search Filters -->
  <div class="bsr-filters">
    <div class="bsr-filters-grid">

      <div class="bsr-field">
        <label class="bsr-label">Project Number</label>
        <input pInputText type="text" [(ngModel)]="searchModel.projectNumber"
          placeholder="Search project #" class="w-full" />
      </div>

      <div class="bsr-field">
        <label class="bsr-label">Ship Date From</label>
        <p-datePicker [(ngModel)]="searchModel.shipDateFrom" [showIcon]="true"
          [showOnFocus]="false" dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy"
          appendTo="body" class="w-full" />
      </div>

      <div class="bsr-field">
        <label class="bsr-label">Ship Date To</label>
        <p-datePicker [(ngModel)]="searchModel.shipDateTo" [showIcon]="true"
          [showOnFocus]="false" dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy"
          appendTo="body" class="w-full" />
      </div>

      <div class="bsr-field">
        <label class="bsr-label">Integrator</label>
        <p-select [(ngModel)]="searchModel.integratorId" [options]="integratorList"
          optionLabel="name" optionValue="integratorId"
          appendTo="body" class="w-full" />
      </div>

      <div class="bsr-field">
        <label class="bsr-label">Ship To Location</label>
        <input pInputText type="text" [(ngModel)]="searchModel.shipToLocation"
          placeholder="Address, city or state" class="w-full" />
      </div>

      <div class="bsr-field">
        <label class="bsr-label">Arrival Date From</label>
        <p-datePicker [(ngModel)]="searchModel.arrivalDateFrom" [showIcon]="true"
          [showOnFocus]="false" dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy"
          appendTo="body" class="w-full" />
      </div>

      <div class="bsr-field">
        <label class="bsr-label">Arrival Date To</label>
        <p-datePicker [(ngModel)]="searchModel.arrivalDateTo" [showIcon]="true"
          [showOnFocus]="false" dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy"
          appendTo="body" class="w-full" />
      </div>

      <div class="bsr-field bsr-checkboxes">
        <label class="bsr-label">Flags</label>
        <div class="bsr-checkbox-row">
          <p-checkbox [(ngModel)]="searchModel.overWeight" [binary]="true" inputId="overWeight" />
          <label for="overWeight" class="bsr-checkbox-label">Over Weight</label>
          <p-checkbox [(ngModel)]="searchModel.overDimension" [binary]="true" inputId="overDimension" />
          <label for="overDimension" class="bsr-checkbox-label">Over Dimension</label>
        </div>
      </div>

      <div class="bsr-field bsr-actions-field">
        <p-button label="Clear" severity="secondary" icon="ri-close-line"
          iconPos="left" (click)="onClear()" />
        <p-button label="{{ loading ? 'Searching...' : 'Search' }}" icon="ri-search-line"
          iconPos="left" (click)="onSearch()" [disabled]="loading" />
      </div>

    </div>
  </div>

  <!-- Results Header -->
  @if (searched) {
    <div class="bsr-results-header">
      <span class="bsr-results-count">{{ reportData.length }} result(s)</span>
      <p-button label="{{ exporting ? 'Exporting...' : 'Export to Excel' }}"
        icon="ri-file-excel-line" iconPos="left" severity="secondary"
        (click)="onExport()" [disabled]="exporting || !reportData.length" />
    </div>
  }

  <!-- Data Grid -->
  <div class="bsr-table-wrapper">
    <p-table [value]="reportData" [scrollable]="true" scrollHeight="flex"
      [loading]="loading" [virtualScroll]="true" [virtualScrollItemSize]="48"
      styleClass="bsr-table">
      <ng-template pTemplate="header">
        <tr>
          <th class="sticky-col sticky-col-1">Project #</th>
          <th class="sticky-col sticky-col-2">Project Name</th>
          <th style="min-width:140px;">Shipping Date</th>
          <th style="min-width:140px;">Arrival Date</th>
          <th style="min-width:200px;">Integrator MVPS Serial No.</th>
          <th style="min-width:150px;">Customer MVPS #</th>
          <th style="min-width:150px;">MVPS Configuration</th>
          <th style="min-width:150px;">Bill of Lading</th>
          <th style="min-width:160px;">Appointment Time</th>
          <th style="min-width:120px;">Over Weight</th>
          <th style="min-width:130px;">Over Dimension</th>
          <th style="min-width:200px;">Logistics Comment</th>
          <th style="min-width:140px;">Delivery Date</th>
          <th style="min-width:150px;">Shipping Status</th>
          <th style="min-width:200px;">Inverter 1 Serial No</th>
          <th style="min-width:150px;">Inverter 1 IGBT</th>
          <th style="min-width:200px;">Inverter 2 Serial No</th>
          <th style="min-width:150px;">Inverter 2 IGBT</th>
          <th style="min-width:200px;">Inverter 3 Serial No</th>
          <th style="min-width:150px;">Inverter 3 IGBT</th>
          <th style="min-width:200px;">Inverter 4 Serial No</th>
          <th style="min-width:150px;">Inverter 4 IGBT</th>
          <th style="min-width:200px;">Inverter 5 Serial No</th>
          <th style="min-width:150px;">Inverter 5 IGBT</th>
          <th style="min-width:200px;">Inverter 6 Serial No</th>
          <th style="min-width:150px;">Inverter 6 IGBT</th>
          <th style="min-width:200px;">Inverter 7 Serial No</th>
          <th style="min-width:150px;">Inverter 7 IGBT</th>
          <th style="min-width:130px;">SCU Installed?</th>
          <th style="min-width:130px;">DIS Installed?</th>
          <th style="min-width:150px;">EPANB Installed?</th>
          <th style="min-width:160px;">DC Fuses Installed?</th>
          <th style="min-width:180px;">Estimated Delivery Date</th>
          <th style="min-width:150px;">MV Xfmr Design</th>
          <th style="min-width:150px;">MV Xfmr #</th>
          <th style="min-width:150px;">LV Xfmr #</th>
          <th style="min-width:130px;">Bushing Size</th>
          <th style="min-width:180px;">SCADA #</th>
          <th style="min-width:150px;">Tracker #1</th>
          <th style="min-width:200px;">Wildlife Repellent Added?</th>
          <th style="min-width:230px;">Wildlife Warning Label Applied?</th>
          <th style="min-width:250px;">Notes</th>
          <th style="min-width:150px;">MVPS Status</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td class="sticky-col sticky-col-1">{{ row.projectNumber }}</td>
          <td class="sticky-col sticky-col-2">{{ row.projectName }}</td>
          <td>{{ row.shipDate | date:'mediumDate' }}</td>
          <td>{{ row.arrivalDate | date:'mediumDate' }}</td>
          <td>{{ row.integratorSkidSerialNo }}</td>
          <td>{{ row.customerSkidNumber }}</td>
          <td>{{ row.skidConfiguration }}</td>
          <td>{{ row.billOfLading }}</td>
          <td>{{ row.appointmentTime | date:'mediumDate' }}</td>
          <td>{{ row.overWeight ? 'Yes' : 'No' }}</td>
          <td>{{ row.overDimension ? 'Yes' : 'No' }}</td>
          <td>{{ row.logisticsComment }}</td>
          <td>{{ row.deliveryDate | date:'mediumDate' }}</td>
          <td>{{ row.shippingStatus }}</td>
          <td>{{ row.inv1SerialNo }}</td>
          <td>{{ row.inv1Igbt }}</td>
          <td>{{ row.inv2SerialNo }}</td>
          <td>{{ row.inv2Igbt }}</td>
          <td>{{ row.inv3SerialNo }}</td>
          <td>{{ row.inv3Igbt }}</td>
          <td>{{ row.inv4SerialNo }}</td>
          <td>{{ row.inv4Igbt }}</td>
          <td>{{ row.inv5SerialNo }}</td>
          <td>{{ row.inv5Igbt }}</td>
          <td>{{ row.inv6SerialNo }}</td>
          <td>{{ row.inv6Igbt }}</td>
          <td>{{ row.inv7SerialNo }}</td>
          <td>{{ row.inv7Igbt }}</td>
          <td>{{ row.scu }}</td>
          <td>{{ row.dis }}</td>
          <td>{{ row.epanb }}</td>
          <td>{{ row.dcFuses }}</td>
          <td>{{ row.estimatedDeliveryDate | date:'mediumDate' }}</td>
          <td>{{ row.mvXfmrDesign }}</td>
          <td>{{ row.mvXfmrSerialNo }}</td>
          <td>{{ row.lvXfmrSerialNo }}</td>
          <td>{{ row.bushingSize }}</td>
          <td>{{ row.scadaSerialNo }}</td>
          <td>{{ row.trackerSerialNo1 }}</td>
          <td>{{ row.wildlifeRepellentAdded }}</td>
          <td>{{ row.wildlifeWarningLabelApplied }}</td>
          <td>{{ row.notes }}</td>
          <td>{{ row.skidStatus }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="43">
            <div class="bsr-empty">
              @if (!searched) {
                <i class="ri-search-line bsr-empty-icon"></i>
                <span>Use the filters above and click Search to load results.</span>
              } @else {
                <i class="ri-inbox-line bsr-empty-icon"></i>
                <span>No records found.</span>
              }
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

</div>
